import { Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { t } from 'i18next'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { styled } from 'styled-components'
import { SectionLoadingState } from '../../../../components'
import { NO_DATA_PLACEHOLDER } from '../../../../constants/constants'
import { useAlgorithmRunDetails } from '../../../../hooks'
import useWorkspaceDetails from '../../../../hooks/useWorkspaceDetails'
import { CompensationMatrixAnalysisFilteringRunResultExperiment } from '../../../../store/reducers/workspaceReducer'
import { SmartFunctionListPanelLayout } from '../../components/SmartFunctionListPanelLayout'

const SectionLoadingStateContainer = styled.div`
  display: flex;
  height: calc(100vh - 224px);
`

const CompensationMatrixAnalysisSmartFunctionDetailsPageFilteringPanel = () => {
  const { workspaceId, algorithmRunId } = useParams()

  const { selectedWorkspace } = useWorkspaceDetails({
    workspaceId,
    preventFetch: true,
  })

  const { loading, selectedAlgorithmRun } = useAlgorithmRunDetails({
    workspaceId,
    algorithmRunId,
    preventFetch: true,
  })

  const formattedData: CompensationMatrixAnalysisFilteringRunResultExperiment[] =
    [
      {
        id: '1',
        src: 'src',
        cytometer: 'Hard coded cytometer',
        experimentName: `Hard coded name  - ${
          selectedWorkspace?.algorithmName
        } - ${selectedAlgorithmRun?.id || 0}`,
        fluorochrome: 'f',
        marker: 'm',
        compensationApplied: 'n',
      },
    ]

  const columns: ColumnsType<CompensationMatrixAnalysisFilteringRunResultExperiment> =
    useMemo(
      () => [
        {
          title: t(
            'smartFunctionDetailsPage.cellCartaCompensationMatrixAnalysis.tableTitles.src',
          ),
          dataIndex: 'src',
          key: 'src',
          width: '30%',
          render: (text, record) => <>{text || NO_DATA_PLACEHOLDER}</>,
        },
        {
          title: t(
            'smartFunctionDetailsPage.cellCartaCompensationMatrixAnalysis.tableTitles.cytometer',
          ),
          dataIndex: 'cytometer',
          key: 'cytometer',
          width: '30%',
          render: (text, record) => <>{text || NO_DATA_PLACEHOLDER}</>,
        },
        {
          title: t(
            'smartFunctionDetailsPage.cellCartaCompensationMatrixAnalysis.tableTitles.experimentName',
          ),
          dataIndex: 'experimentName',
          key: 'experimentName',
          width: '30%',
          render: (text, record) => <>{text || NO_DATA_PLACEHOLDER}</>,
        },
        {
          title: t(
            'smartFunctionDetailsPage.cellCartaCompensationMatrixAnalysis.tableTitles.compensationApplied',
          ),
          dataIndex: 'compensationApplied',
          key: 'compensationApplied',
          width: '30%',
          render: (text, record) => <>{text || NO_DATA_PLACEHOLDER}</>,
        },
        {
          title: t(
            'smartFunctionDetailsPage.cellCartaCompensationMatrixAnalysis.tableTitles.marker',
          ),
          dataIndex: 'marker',
          key: 'marker',
          width: '30%',
          render: (text, record) => <>{text || NO_DATA_PLACEHOLDER}</>,
        },
        {
          title: t(
            'smartFunctionDetailsPage.cellCartaCompensationMatrixAnalysis.tableTitles.fluorochrome',
          ),
          dataIndex: 'fluorochrome',
          key: 'fluorochrome',
          width: '30%',
          render: (text, record) => <>{text || NO_DATA_PLACEHOLDER}</>,
        },
      ],
      [],
    )

  return loading ? (
    <SectionLoadingStateContainer>
      <SectionLoadingState />
    </SectionLoadingStateContainer>
  ) : (
    <SmartFunctionListPanelLayout>
      <Table
        columns={columns}
        dataSource={formattedData}
        loading={loading}
        rowKey="key"
        pagination={false}
        scroll={{ y: 'calc(100vh - 190px)' }}
        rowClassName="page-list-table-row"
      />
    </SmartFunctionListPanelLayout>
  )
}

export default CompensationMatrixAnalysisSmartFunctionDetailsPageFilteringPanel
